import { Element } from './Element'

export class DefsElement extends Element {
  override type = 'defs'

  override render() {
    // NOOP
  }
}
